import { Box, Grid, Typography } from '@material-ui/core'
import { formatMoney, Translator } from '@itarget/shared'
import { makeStyles } from '@material-ui/styles'
import { useSelector } from 'react-redux'

const useStyles = makeStyles((theme) => ({
  selectedItemsContainerStyle: {
    display: 'flex',
    gap: theme.spacing(0.5),
    flexDirection: 'column',
    borderRadius: theme.spacing(1),
    marginBottom: theme.spacing(1.5),
    padding: theme.spacing(1.5, 1),
    backgroundColor: theme.palette.listItensCart.containerBackgroundColor,
    [theme.breakpoints.up(theme.breakpoints.values.xs)]: {
      flexWrap: 'wrap',
    },
    [theme.breakpoints.up(theme.breakpoints.values.sm)]: {
      flexWrap: 'nowrap',
    },
  },
  selectedItemStyle: {
    [theme.breakpoints.up(theme.breakpoints.values.xs)]: {
      width: '100%',
    },
    [theme.breakpoints.up(theme.breakpoints.values.sm)]: {
      width: 'auto',
    },
  },
  description: {
    fontWeight: 500,
    lineHeight: 1.08,
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.listItensCart.textColor,
  },
  taxedValue: {
    textDecoration: 'line-through',
    fontSize: theme.typography.pxToRem(14),
    lineHeight: 1,
    color: theme.palette.listItensCart.discountedColor,
  },
  value: {
    lineHeight: 1,
    marginLeft: theme.spacing(1.25),
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.listItensCart.textColor,
  },
}))

const ListItensCart = ({ selected, subscriptionComboApi }) => {
  const systemTheme = useSelector((state) => state.theme.systemTheme)
  const styles = useStyles({ theme: systemTheme })

  // Função para verificar se há múltiplas parcelas da mesma atividade
  const hasMultipleInstallments = (currentItem) => {
    if (!selected || selected.length <= 1) return false;
    
    const sameActivityItems = selected.filter(item => 
      item.descricao === currentItem.descricao
    );
    
    return sameActivityItems.length > 1;
  };



  const valueVoucher = (value, discountType, discount) => {
    if (discountType === 'P') {
      return value * (discount / 100)
    }
    if (discountType === 'V') {
      return parseFloat(discount)
    }
    return 0
  }
  const changeValues = (item) => {
    let value = 'R$' + formatMoney.toReal(item.cr_valor)

    let inscricao = undefined
    if (subscriptionComboApi?.data.length > 0) {
      inscricao = subscriptionComboApi?.data.find((i) => item.inscricao_uuid === i.inscricao_id) || null

      if (inscricao) {
        // Base correto para combo: sempre partir do valor retornado pela API do combo
        let baseValue = Number(inscricao.valor || 0)
        let newValue = baseValue - Number(inscricao.valor_desconto || 0)

        if (inscricao.tipo_desconto_voucher && inscricao.valor_voucher) {
          const voucherDiscount = valueVoucher(newValue, inscricao.tipo_desconto_voucher, inscricao.valor_voucher)
          newValue -= voucherDiscount
        }

        const hasDiscount = Number(baseValue.toFixed(2)) !== Number(newValue.toFixed(2))

        return hasDiscount ? (
          <Box
            display='flex'
            alignItems='center'
            justifyContent='flex-end'>
            <Typography
              variant='caption'
              className={styles.taxedValue}>
              R$ {formatMoney.toReal(baseValue)}
            </Typography>
            <Typography
              variant='caption'
              className={styles.value}>
              R$ {formatMoney.toReal(newValue)}
            </Typography>
          </Box>
        ) : (
          <Box
            display='flex'
            flexDirection='column'
            alignItems='flex-end'>
            <Typography
              variant='caption'
              className={styles.value}>
              R$ {formatMoney.toReal(newValue)}
            </Typography>
          </Box>
        )
      }
    }

    if (item?.valor_desconto) {
      return (
        <Box
          display='flex'
          flexDirection='column'
          alignItems='flex-end'>
          <Typography
            variant='caption'
            className={styles.taxedValue}>
            R$ {formatMoney.toReal(item?.valor)}
          </Typography>
          <Typography
            variant='caption'
            className={styles.value}>
            R$ {formatMoney.toReal(item?.cr_valor)}
          </Typography>
        </Box>
      )
    }

    return (
      <Box
        display='flex'
        flexDirection='column'
        alignItems='flex-end'>
        <Typography
          variant='caption'
          className={styles.value}>
          {value}
        </Typography>
      </Box>
    )
  }

  const listItens = (row) => {
    let gridArray = []
    let descricaoAtvds = row.titulo.split(', ')
    for (let index = 0; index < row.inscricao_uuid.length; index++) {
      let inscricao = subscriptionComboApi?.data.find((i) => row.inscricao_uuid[index] === i.inscricao_id) || null
      if (inscricao) {
        gridArray.push(
          <Grid
            key={index}
            container>
            <Grid
              className='title'
              item
              xs={8}>
              <Grid>
                <b>
                  {descricaoAtvds[index]}
                  {inscricao && inscricao.parcela && (
                  <span style={{ fontSize: '0.8em', color: '#666', marginLeft: '8px', fontWeight: 'normal' }}>
                    {inscricao.parcela === 0 ? 'Matrícula' : `Parcela ${inscricao.parcela}`}
                  </span>
                )}
                </b>
              </Grid>
            </Grid>
            <Grid
              className='price'
              item
              xs={4}>
              {row.inscricao_valor[index] > 0 ? (
                `R$${formatMoney.toReal(row.inscricao_valor[index])}`
              ) : (
                <b className='green'>CORTESIA</b>
              )}
            </Grid>
          </Grid>
        )
      }
    }
    return gridArray
  }

  return (
    <>
      <div>
        {selected && selected?.length <= 0 && (
          <span>
            <Translator transRef='translation.Não há itens no carrinho.' />
          </span>
        )}
        {selected && selected?.length <= 0 && selected?.length > 0 && (
          <span>
            <Translator transRef='translation.Não há itens selecionados.' />
          </span>
        )}
      </div>
      {selected &&
        selected.length > 0 &&
        selected.map((row, i) => {
          return parseInt(Object.keys(row?.conta_receber_id).length) < row?.inscricao_uuid?.length ? (
            listItens(row)
          ) : (
            <Box
              key={i}
              container
              className={styles.selectedItemsContainerStyle}
              xs={12}>
              <Grid
                item
                className={styles.selectedItemStyle}>
                <Typography className={styles.description}>
                  {row.descricao}
                  {(() => {
                    if (row && row.parcela !== undefined && row.parcela !== null) {
                      if (row.parcela === 0) {
                        return (
                          <span style={{ fontSize: '0.8em', color: '#666', marginLeft: '8px' }}>
                            Matrícula
                          </span>
                        );
                      }
                      
                      const sameActivityItems = selected.filter(item => 
                        item.descricao === row.descricao && 
                        item.parcela !== undefined && 
                        item.parcela !== null
                      );
                      
                      if (sameActivityItems.length > 1) {
                        return (
                          <span style={{ fontSize: '0.8em', color: '#666', marginLeft: '8px' }}>
                            Parcela {row.parcela}
                          </span>
                        );
                      }
                    }
                    return '';
                  })()}
                </Typography>
              </Grid>
              <Grid
                item
                className={styles.selectedItemStyle}>
                {changeValues(row)}
              </Grid>
            </Box>
          )
        })}
    </>
  )
}

export default ListItensCart
